import React, { useState } from "react";
import BookingSidebar from "./bookingSideBar";
import UpdateBooking from "./updateBooking";

const Update = () => {
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8 h-screen" style={{height:"calc(100vh - 110px)"}}>
      {/* <header className="flex justify-between items-center sm:flex sm:justify-between sm:items-center mb-5">
        <div className="sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
            Update Booking
          </h1>
        </div>
      </header> */}
      <UpdateBooking />
    </div>
  );
};
Update.auth = { path: "/booking/update", role: "super-admin admin" };
export default Update;
